module.exports = __webpack_public_path__ + "static/img/sample_thumbnail.7c82282.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/works/video-archive/sample_thumbnail.jpg
// module id = fpOf
// module chunks = 0